// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5c403557","893":"e374de57"}[chunkId] + ".chunk.js";
};